const defaultSocialHeaderButtonEditingConfig = {
  title: "Facebook Social Header Button",
  properties: ["link", "title", "body"],
};

export default defaultSocialHeaderButtonEditingConfig;
